import Vue from 'vue';

export default {
  name: 'SpotBillReceipt',
  props: {
    //model: {
    //  type: Object,
    //  required: true,
    //},
    consumptionCharges: {
      type: Array,
      required: true,
    },
    transactionTypes: {
      type: Array,
      required: true,
    },
    vatRateHistories: {
      type: Array,
      required: true,
    },
    regularCharges: {
      type: Array,
      required: true,
    },
    excludedConsumptionTypeCharges: {
      type: Array,
      required: true,
    },
    excludedTownshipCharges: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {

    }
  },
  computed: {},
  watch: {},
  created() { },
  methods: {
    //calculateConsumptionCharges(serviceTransactionType, from, to, consumption, units, tariffId, targetDate, timeEffectCoeff, chargeDetails, chargeDetailSourceType) {
    //  var transactions = [];

    //  from = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    //  to = new Date(to.getFullYear(), to.getMonth(), to.getDate());
    //  targetDate = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());

    //  if (to < from) {
    //    throw new Error(`Wrong meter reading interval '${from}' - '${to}'`);
    //  }

    //  if (to.getTime() === from.getTime()) {
    //    to.setDate(to.getDate() + 1);
    //  }

    //  var amount = 0;

    //  var tariffs = consumptionCharges[tariffId];
    //  if (tariffs == null) {
    //    throw new Error(`There is no tariff '${tariffId}'`);
    //  }

    //  var tariffActual = tariffs[0];

    //  if (tariffActual == null) {
    //    throw new Error(`There is no actual tariff '${tariffId}'`);
    //  }

    //  var tariffDays = {};

    //  var readingRange = new DateRange(from, to);

    //  var prev = null;
    //  for (var i = 0; i < tariffs.length; i++) {
    //    var tariff = tariffs[i];
    //    var range = new DateRange(tariff.EffectiveDate, prev != null ? prev.EffectiveDate : new Date(8640000000000000));
    //    var overlapping = readingRange.getOverlappedRange(range);
    //    if (overlapping.Days > 0) {
    //      tariffDays[tariff] = overlapping.Days;
    //    }

    //    prev = tariff;
    //  }

    //  if (Object.keys(tariffDays).length === 0) {
    //    throw new Error(`There is no suitable effective tariff(s) found for tarrif '${tariffId}'`);
    //  }

    //  tariffs = tariffs.filter(function (i) {
    //    return tariffDays.hasOwnProperty(i);
    //  });

    //  var dailyFlow = 0;

    //  var timeEffect = Object.keys(tariffDays).every(function (i) {
    //    return i.IgnoreTimeffect == null || i.IgnoreTimeffect === 0;
    //  });

    //  if (timeEffect) {
    //    var days = Math.round((to - from) / (1000 * 60 * 60 * 24));

    //    var months = Math.round(days / Settings.DaysInMonth, Settings.ConsumptionPrecision);
    //    var timeEffectConsumption = Math.round(consumption / months, Settings.ConsumptionPrecision);
    //    dailyFlow = Math.round(consumption / (days * 1.0), Settings.ConsumptionPrecision) / units;
    //  } else {
    //    dailyFlow = Math.round(consumption / (Settings.DaysInMonth * (tariffActual.BandsNoMonths != null ? tariffActual.BandsNoMonths : 1)), Settings.ConsumptionPrecision) / units;
    //  }

    //  if (!timeEffect) {
    //    var maxEffectiveDate = Object.keys(tariffDays).map(function (i) {
    //      return i.EffectiveDate;
    //    }).reduce(function (a, b) {
    //      return a > b ? a : b;
    //    });
    //    tariffDays = {
    //      [Object.keys(tariffDays).find(function (i) {
    //        return i.EffectiveDate.getTime() === maxEffectiveDate.getTime();
    //      })]: Object.values(tariffDays).reduce(function (a, b) {
    //        return a + b;
    //      })
    //    };
    //  }

    //  var consTrType = _transactionTypes.find(function (i) {
    //    return i.TransCode === serviceTransactionType && i.Trans
    //  }
    //},
  }
}
